import React, { useEffect, useState } from 'react';

// Comps
import AccountSectionLayout from '@project-stories/ecommerce/Account/AccountSectionLayout';
import { Paragraph } from '@arctheme-components/elements/Paragraph/Paragraph';
import { Link } from '@arctheme-components/elements/Link/Link';
import ProductTile from '@src/stories/ecommerce/Product/ProductTile';
import { LoadingSpinner } from '@arctheme-components/elements/LoadingSpinner/LoadingSpinner';

// Store
import useLocalWishlistStore from '@src/stores/localWishlistStore';

// Utils
import shopifyHelpers from 'frontend/js/shopify';

export const AccountWishlist = ({ settings, locales }) => {
  // Store
  // Local storage wishlist
  const localLists = useLocalWishlistStore((state) => state.localLists);

  // States
  const [products, setProducts] = useState(null);
  const [isLoadingProducts, setIsLoadingProducts] = useState(false);

  // Re-fetch products when there are updates in wishlist
  useEffect(() => {
    const fetchProducts = async () => {
      setProducts(null);
      setIsLoadingProducts(true);

      const wishlist = localLists?.[0];

      if (!wishlist) {
        setIsLoadingProducts(false);
        return;
      }

      const graphQlProducts = await shopifyHelpers.getShopifyProductList(wishlist.products);

      setProducts(graphQlProducts);
      setIsLoadingProducts(false);
    };

    fetchProducts();
  }, [localLists]);

  return (
    <AccountSectionLayout
      classes={`lg:pl-[98px] md:pt-8 hide-scrollbar ${
        products && products.length ? 'md:min-h-[400px]' : 'h-[50vh] lg:h-[80vh]'
      }`}
    >
      {isLoadingProducts ? (
        // TODO: Replace with appropriate loader
        <div className='pb-4'>
          <LoadingSpinner id='spinner-account-wishlist' />
        </div>
      ) : products && products.length ? (
        <div className='grid grid-cols-2 gap-x-4 xl:gap-x-[38px] gap-y-[101px] lg:gap-y-[31px] pb-6'>
          {products.map((product) => (
            <ProductTile
              key={product.id}
              product={product}
              swatches={product?.swatches}
              siblings={undefined}
              settings={settings}
              enableWishlist={true}
              type='wishlist'
            />
          ))}
        </div>
      ) : (
        <div className='text-center pb-4'>
          <Paragraph
            type='b2 text-center'
            text={locales.empty}
          />
          <Link
            link='/collections/all'
            classes='button btn-secondary mt-6'
          >
            Continue Shopping
          </Link>
        </div>
      )}
    </AccountSectionLayout>
  );
};
